import { styled, css } from 'styled-components';
export const StyledInputContainer = styled.div `
  overflow: hidden;
  max-height: 36px;
  min-width: 36px;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;

  ${({ width }) => width &&
    css `
      width: ${width}px;
    `}

  ${({ theme, $inputDisabled }) => css `
    border: 1px solid ${$inputDisabled ? theme.colors.grey30_2 : theme.colors.grey30_1};
    background-color: ${$inputDisabled ? theme.colors.grey05_3 : theme.colors.grey00_7};
  `}

  /* Hover state - only when not disabled, not focused and no success/warning/error */
  ${({ theme, $success, $warning, $error, $inputDisabled }) => !$inputDisabled &&
    !$success &&
    !$warning &&
    !$error &&
    css `
      &:hover:not(:focus-within) {
        border: 1px solid ${theme.colors.grey70_1};
      }
    `}

  /* Success state */
  ${({ theme, $success }) => $success &&
    css `
      border: 1px solid ${theme.colors.positive70};
      &:focus-within {
        ${theme.shadows.success};
      }
    `}

  /* Warning state */
  ${({ theme, $warning }) => $warning &&
    css `
      border: 1px solid ${theme.colors.warning70};
      &:focus-within {
        ${theme.shadows.warning};
      }
    `}

  /* Error state */
  ${({ theme, $error }) => $error &&
    css `
      border: 1px solid ${theme.colors.critical70};
      &:focus-within {
        ${theme.shadows.error};
      }
    `}

  /* Default focus state - only when no success/warning/error */
  ${({ theme, $success, $warning, $error }) => !$success &&
    !$warning &&
    !$error &&
    css `
      &:focus-within {
        ${theme.shadows.focus};
        border: 1px solid ${theme.colors.main};
      }
    `}
`;
